module.exports = __webpack_public_path__ + "static/media/tvIcon.581f2cbf.svg";